import { Stack, Typography } from "@mui/material";
import { DataUploadMethods } from "./DataUploadMethods";
import { CampaignSavedData } from "../../../../../types/apiTypes";

export const TargetAccountsStep = ({
  resultData,
  backHandler,
}: {
  resultData: CampaignSavedData;
  backHandler: () => void;
}) => {
  return (
    <Stack gap="24px" width="100%">
      <Stack>
        <Typography
          component="span"
          variant="subtitle1"
          sx={{ color: "#464646" }}
        >
          You can upload available account and contact data for buying committee
          discovery now or do it later.
        </Typography>
      </Stack>
      <DataUploadMethods resultData={resultData} backHandler={backHandler} />
    </Stack>
  );
};
